<template>
<div >
  <div class="detailsTitle">
      <h4>订单详情</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
  <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" label-position="left"   class="demo-form-inline" size="mini">
    <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>单据信息</span>
        </h4>
    </div>
    <el-form-item label="订单编号:"  >
      <div class="width2">{{goodform.orderNo}}</div>
    </el-form-item>
    <el-form-item label="销售合同:"  >
      <div class="width2">{{goodform.salesContract?goodform.salesContract:'-'}}</div>
    </el-form-item>
    <el-form-item label="项目名称:"  >
      <div class="width2">{{goodform.projectType}}</div>
    </el-form-item>
    <el-form-item label="业务类型:"  >
      <div class="width2">{{goodform.orderBusinessTypeName}}</div>
    </el-form-item>
    <el-form-item label="业务部门:"  >
      <div class="width2">{{goodform.businessSubunit}}</div>
    </el-form-item>
    <el-form-item label="业务人员:" >
      <div class="width2">{{goodform.businessUser}}</div>
    </el-form-item>
    <el-form-item label="结算客户:"  >
      <div class="width2">{{goodform.payee}}</div>
    </el-form-item>
    <hr>
    <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>收发信息</span>
        </h4>
    </div>
    <div>
      <el-form-item    label="发货人:" prop="deliverPerson" v-if="goodform.deliverAddressId">
        <div style="width:80px">{{goodform.deliverPerson}}</div>
      </el-form-item>
      <el-form-item label="电话:" prop="deliverPhone" v-if="goodform.deliverAddressId">
         <div style="width:80px">{{goodform.deliverPhone}}</div>
      </el-form-item>
      <el-form-item   label="流向:" v-if="goodform.deliverAddressId">
         <div style="width:200px">{{goodform.startDirection}}</div>
      </el-form-item>
      <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1" v-if="goodform.deliverAddressId">
         <div style="min-width:150px">{{goodform.deliverAddress}}</div>
      </el-form-item>
    </div>
    <div>
      <el-form-item  label="收货人:" prop="receivingPerson" v-if="goodform.receivingAddressId">
         <div style="width:80px">{{goodform.receivingPerson}}</div>
      </el-form-item>
      <el-form-item label="电话:" prop="receivingPhone" v-if="goodform.receivingAddressId">
         <div style="width:80px">{{goodform.receivingPhone}}</div>
      </el-form-item>
      <el-form-item label="流向:" prop="receivingCompany" v-if="goodform.receivingAddressId">
         <div style="width:200px">{{goodform.endDirection}}</div>
      </el-form-item>
      <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1" v-if="goodform.receivingAddressId">
         <div style="min-width:150px">{{goodform.receivingAddress}}</div>
      </el-form-item>
    </div>
    <el-form-item  label="共计：" >
          <div><span class="red">{{goodform.kilometres}}</span>公里（{{goodform.arriveDepartFlag=='是'?'往返':'单程'}}）</div>
      </el-form-item>
    <hr>
     <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>货物信息</span>
        </h4>
    </div>
    <el-form-item  label="货物类型:" >
        <div style="width:80px">{{goodform.productTypeName}}</div>
    </el-form-item>
    <el-form-item  label="计量单位:" >
        <div style="width:80px">{{goodform.measuringUnit}}</div>
    </el-form-item>
    <el-form-item  label="重量(吨):">
        <div style="width:80px">{{goodform.weight?goodform.weight:'-'}}</div>
    </el-form-item>
    <el-form-item  label="数量(件):">
        <div style="width:80px">{{goodform.orderNumber?goodform.orderNumber:'-'}}</div>
    </el-form-item>
    <el-form-item  label="体积(方):">
        <div style="width:80px">{{goodform.volumn?goodform.volumn:'-'}}</div>
    </el-form-item>
    <el-form-item  label="货物备注:">
        <div style="width:80px">{{goodform.productRemark?goodform.productRemark:'-'}}</div>
    </el-form-item>
  <div style="padding:0 16px 16px 16px;" v-if="goodform.goodsList.length>0">
    <el-table height="300px" size="mini" ref="tabref" :data="goodform.goodsList" style="width:100%" border center>
      <el-table-column type="index"  label="序号" width="60"></el-table-column>
      <el-table-column :show-overflow-tooltip="true"  prop="customerName"
        label="货权客户" min-width="180" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号"
        min-width="180" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="number" label="数量(件)"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="volumn" label="体积(方)"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="model" label="材质"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位"
          min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号"
        min-width="120" :formatter="formatterRowEmpty"></el-table-column>
    </el-table>
  </div>
  <hr>
  <div class="addressBox">
    <h4 class="title">
      <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>运输要求</span>
    </h4>
  </div>
  <el-form-item label="要求到达时间:" >
    <div class="width1">{{goodform.arrivalTime|dateFormat}}</div>
  </el-form-item>
  <el-form-item label="需求车型:"   >
    <div class="width1">{{goodform.requiredModel?goodform.requiredModel:'-'}}</div>
  </el-form-item>
  <el-form-item label="需求车长:"   >
    <div class="width1">{{goodform.needLength?goodform.needLength:'-'}}</div>
  </el-form-item>
  <el-form-item label="回单要求:"  >
    <div class="width1">{{goodform.receiptRequest?goodform.receiptRequest:'-'}}</div>
  </el-form-item>
  <br>
  <el-form-item label="提货到场时间:"  >
    <div style="width:430px" v-if="goodform.pickupTimeStart">{{goodform.pickupTimeStart|dateFormat}}-{{goodform.pickupTimeEnd|dateFormat}}</div>
    <div v-else style="width:430px">-</div>
  </el-form-item>
  <el-form-item label="提货紧急程度:"  >
    <div class="width1" v-if="goodform.urgencyFlag||goodform.urgencyFlag==0">{{['正常','紧急','加急'][goodform.urgencyFlag]}}</div>
    <div v-else>-</div>
  </el-form-item>
  <br>
  <el-form-item label="备注:" class="remark" prop="remark" >
    <div>{{goodform.remark?goodform.remark:'-'}}</div>
  </el-form-item>
  <hr>
  <div class="addressBox inpBox" style="margin-bottom:20px;" >
    <h4 class="title">
      <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>收入结算信息</span>
    </h4>
    <el-table :data="[{}]"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border>
      <el-table-column label="收入方式" min-width="120">
        <template >
          <div>
            {{[ "月结", "现结"][goodform.incomePattern]}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否开票" min-width="120">
        <template >
          <div>
             {{goodform.makeTicketYn}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否一票制" min-width="120">
        <template >
          <div>
             {{goodform.ticketSystemYn}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入计价" min-width="120">
        <template >
          <div>
            {{goodform.revenueValuationName}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入单价(元)" min-width="120">
        <template >
          <div>
             {{goodform.incomeUnitPrice|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入金额(元)" min-width="120">
        <template >
          <div>
             {{goodform.incomeAmount|moneyFormatNew}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入税率" min-width="120">
        <template >
          <div>
             {{goodform.taxRate}}%
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div class="addressBox">
    <h4 class="title">
      <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>附件</span>
    </h4>
  </div>
  <div class="fujianBox">
      <el-button type="text" v-for="item in fujianList" @click="fujianClick(item)" :key="item.id">{{item.name}}</el-button>
  </div>
  <hr>
  <div class="addressBox">
    <h4 class="title">
      <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>操作日志</span>
    </h4>
  </div>
  <div style="margin-left:24px">
    <el-timeline>
    <el-timeline-item
        v-for="(item, index) in logList"   color="rgb(147, 210, 243)"
        :key="index"
        :timestamp="item.createTime|dateFormat">
        {{item.content}}&nbsp;&nbsp;{{item.createUser}}<br>
        <spna v-if="item.content=='作废'">作废原因：{{item.remark}}</spna>
      </el-timeline-item>
    </el-timeline>
  </div>
</el-form>
<el-dialog  title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag"
  append-to-body width="800px" center>
  <div style="text-align: right;">
    <div id="printMe"  ref="print">
      <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
    </div>
  </div>
</el-dialog>
</div>
</template>

<script>
import { getOrderInfo } from '@/api/newTMS'
import { formatterRowEmpty } from '@/utils/util'
export default {
  data () {
    let id = this.$route.query.id
    return {
      formatterRowEmpty: formatterRowEmpty,
      id: id,
      goodform: { goodsList: [] },
      fujianList: [],
      lookImgFlag: false,
      imgUrl: '',
      logList: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getOrderInfo({ orderBusinessId: this.id }).then(res => {
      this.goodform = res.tOrder
      this.logList = res.serviceLogList
      this.fujianList = []
      res.tAttachmentsList.forEach(item => {
        var filename = item.url.split('/').pop()
        this.fujianList.push({
          name: filename,
          url: item.fileKeyUrl
        })
      })
      this.$set(this.goodform, 'payee', res.tOrderBusiness.payee)
      this.$set(this.goodform, 'orderBusinessType', res.tOrder.orderBusinessType.toString())
      this.$set(this.goodform, 'productType', res.tOrder.productType.toString())
      this.$set(this.goodform, 'goodsList', res.goodslist)
      if (res.tOrderBusiness.incomePattern.toString()) {
        this.$set(this.goodform, 'incomePattern', res.tOrderBusiness.incomePattern.toString())
      }
      if (res.tOrderBusiness.revenueValuation.toString()) {
        this.$set(this.goodform, 'revenueValuation', res.tOrderBusiness.revenueValuation.toString())
        this.$set(this.goodform, 'revenueValuationName', res.tOrderBusiness.revenueValuationName)
      }
      this.$set(this.goodform, 'makeTicketYn', res.tOrderBusiness.makeTicketYn)
      this.$set(this.goodform, 'ticketSystemYn', res.tOrderBusiness.ticketSystemYn)
      this.$set(this.goodform, 'incomeUnitPrice', res.tOrderBusiness.incomeUnitPrice / 100)
      this.$set(this.goodform, 'incomeAmount', res.tOrderBusiness.incomeAmount / 100)
      this.$set(this.goodform, 'taxRate', res.tOrderBusiness.taxRate)
    })
  },
  methods: {
    fujianClick (row) {
      if (this.isImage(row.name)) {
        this.lookImgFlag = true
        this.imgUrl = row.url
      } else {
        window.open(row.url)
      }
    },
    isImage (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }

}
</script>

<style scoped lang='less'>
  .width1{
    width:150px
  }
  .width2{
    width: 260px;
  }
  .dizhiIcon{
  font-size: 18px;
  margin-right: 4px;
}
.fujianBox{
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  /deep/.el-button--text{
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
/deep/.el-form-item{
  padding-left:24px;
}
/deep/.el-form-item__label{
  color: #999;
}
</style>
